<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <fa-icon class="prompt-icon text-primary" [icon]="faQuestionCircle"></fa-icon>
</div>
<div class="modal-body">
    <p [innerHtml]="message"></p>
</div>
<div class="modal-footer">
    <button id="btnConfirmYes" type="button" class="btn btn-primary" (click)="yes()">Yes</button>
    <button id="btnConfirmNo" type="button" class="btn btn-secondary" (click)="no()">No</button>
</div>
